import * as React from 'react';
const SvgPositionVoice = (props) => (
  <svg viewBox="0 0 124 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M59.999 81.998H28.094l-22.68 22.705c-1.259 1.26-3.414.37-3.414-1.415V10c0-4.42 3.58-8 8-8h95.998c4.42 0 8 3.58 8 8v63.998c0 4.42-3.58 8-8 8"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.999 44a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM81.998 44a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM34 44a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM65.999 59.999l5.16 17.26 37.069 45.838c2.705 3.38 7.659 3.88 10.989 1.11a7.73 7.73 0 0 0 .99-10.889l-37.049-44.06-17.16-9.26ZM102.728 116.292l5.27-4.294"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPositionVoice;
